import React, { useState } from "react";
import {
  Flex,
  Text,
  Modal,
  Button,
  ModalBody,
  ModalOverlay,
  ModalContent,
  Radio,
  Box,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";

const SelectMethodModal = ({ isOpen, onClose, onSelect }) => {
  const [value, setValue] = useState("");

  const handleNext = () => {
    onSelect(value);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent
        minW={"700px"}
        borderRadius={"16px"}
        p={4}
        alignSelf={"center"}
      >
        <ModalBody
          gap={4}
          display={"flex"}
          // alignItems={"center"}
          flexDirection={"column"}
        >
          <Box>
            <Text
              fontSize={"22px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              color={"#000000"}
            >
              Send a bag
            </Text>
          </Box>
          <Box bg="white" borderRadius="md" mx="auto">
            <RadioGroup onChange={setValue} value={value}>
              <Stack spacing="4">
                <Box
                  border="1px solid"
                  borderColor={value === "kwc" ? "#456EFF" : "gray.300"}
                  bg={value === "kwc" ? "#456EFF0D" : "white"}
                  borderRadius="16px"
                  p="4"
                  cursor="pointer"
                  onClick={() => setValue("kwc")}
                >
                  <Flex align="center">
                    <Radio value="kwc" colorScheme="blue" mr="4" />
                    <Box>
                      <Text
                        fontSize={"22px"}
                        fontFamily={"PlusJakartaSansSemiBold"}
                        color={"#000000"}
                      >
                        DROP OFF AT KWC LOCATION
                      </Text>
                      <Text
                        fontSize={"16px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#000000"}
                        mt={1}
                      >
                        Drop off the bags in the selected KWC location at your
                        own convenience
                      </Text>
                    </Box>
                  </Flex>
                </Box>

                <Box
                  border="1px solid"
                  borderColor={value === "dhl" ? "#456EFF" : "gray.300"}
                  bg={value === "dhl" ? "#456EFF0D" : "white"}
                  borderRadius="16px"
                  p="4"
                  cursor="pointer"
                  onClick={() => setValue("dhl")}
                >
                  <Flex align="center">
                    <Radio value="dhl" colorScheme="blue" mr="4" />
                    <Box>
                      <Text
                        fontSize={"22px"}
                        fontFamily={"PlusJakartaSansSemiBold"}
                        color={"#000000"}
                      >
                        SHIP THROUGH DHL
                      </Text>
                      <Text
                        fontSize="16px"
                        fontFamily="PlusJakartaSansRegular"
                        color="#000000"
                        mt={1}
                      >
                        If the email pop-up is not open automatically, please
                        send your shipping request to{" "}
                        <Text
                          as="a"
                          href="mailto:info@kidswearcollective.com?subject=Send%20bag%20request"
                          color="#456EFF"
                          textDecoration="underline"
                          
                        >
                          info@kidswearcollective.com
                        </Text>
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              </Stack>
            </RadioGroup>

            <Flex justify="flex-end" mt="6" gap={3}>
              <Button
                onClick={onClose}
                w={"174px"}
                h={"40px"}
                background={"transparent"}
                color={"#000000"}
                border={"1px solid #000000"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
              >
                Cancel
              </Button>
              <Button
                bg="#000000"
                borderRadius={8}
                color="#FFFFFF"
                w={"174px"}
                h={"40px"}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
                onClick={handleNext}
              >
                NEXT
              </Button>
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SelectMethodModal;
